import React from 'react';

import { useEmailMessageQuery } from '@dashboard/generated/wp/platform';
import CodeMirrorPreview from '@wp-react/components/CodeMirror/CodeMirrorPreview';

type Props = {
  waypointEventId: string;
};
export default function TemplateData({ waypointEventId }: Props) {
  const { data } = useEmailMessageQuery({ variables: { id: waypointEventId } });
  const model = data?.EmailMessage;
  if (model === undefined) {
    return null;
  }

  const value = JSON.stringify(model.variables, null, '  ');
  return <CodeMirrorPreview key={waypointEventId} language="JSON" value={value} />;
}
